import Phaser from 'phaser';

export function addCoverImage(scene: Phaser.Scene, key: string, depth = 0, alpha = 1) {
  const image = scene.add.image(scene.scale.width / 2, scene.scale.height / 2, key);
  const scale = Math.max(scene.scale.width / image.width, scene.scale.height / image.height);
  return image.setScale(scale).setDepth(depth).setAlpha(alpha);
}

export function setImageHeight(image: Phaser.GameObjects.Image, targetHeight: number) {
  return image.setScale(targetHeight / image.height);
}
